import React from "react";

import { mdiAccountMultiple } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { NavLink, useParams } from "react-router-dom";

import { MENU_ICON_SIZE } from "./Menu";
import MenuItem from "./MenuItem";
import SubMenu from "./SubMenu";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

function CommunitySubMenu(): JSX.Element {
  const { t } = useTranslation("editor-menu");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  return (
    <SubMenu
      icon={<Icon path={mdiAccountMultiple} size={MENU_ICON_SIZE} />}
      label={t("community")}
    >
      <MenuItem
        component={<NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/comments`} />}
        label={t("comments")}
      />
    </SubMenu>
  );
}

export default CommunitySubMenu;
